import { iconFromReactSvg } from '~/components/Abstracts/Icons'

import { ReactComponent as ArrowLeft } from './arrow-left.svg'
import { ReactComponent as BigArrowLeft } from './big-arrow-left.svg'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as Edit } from './edit.svg'
import { ReactComponent as Packet } from './packet.svg'
import { ReactComponent as PlayRounded } from './play-rounded.svg'
import { ReactComponent as Star } from './star.svg'
import { ReactComponent as StoreLocator } from './store-locator.svg'
import css from './styles.module.scss'

export const PlayRoundedIcon = iconFromReactSvg(
  PlayRounded,
  css.PlayRoundedIcon,
)

export const BigArrowLeftIcon = iconFromReactSvg(
  BigArrowLeft,
  css.BigArrowLeftIcon,
)

export const BigArrowRightIcon = iconFromReactSvg(
  BigArrowLeft,
  css.BigArrowRightIcon,
)

export const ArrowLeftIcon = iconFromReactSvg(ArrowLeft, css.ArrowLeftIcon)

export const ArrowRightIcon = iconFromReactSvg(ArrowLeft, css.ArrowRightIcon)

export const CheckIcon = iconFromReactSvg(Check, css.Check)

export const EditIcon = iconFromReactSvg(Edit, css.Edit)

export const StoreLocatorIcon = iconFromReactSvg(StoreLocator, css.StoreLocator)
export const PacketIcon = iconFromReactSvg(Packet, css.Packet)

export const StarIcon = iconFromReactSvg(Star, css.StarIcon)
